<template>
    <div class="relative">
<!--        Floating Label-->
        <label
            :class="labelClasses"
            class="absolute left-4 transition-all duration-200 ease-in-out pointer-events-none"
        >
            {{ label }}
        </label>

<!--        Select Element-->
        <select
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
            @focus="isFocused = true"
            @blur="isFocused = false"
            class="w-full max-h-12 px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent bg-white appearance-none"
        >
            <option value="" disabled></option>
            <slot></slot>
        </select>

<!--        Custom Arrow-->
        <div class="absolute inset-y-0 right-0 flex items-center pr-4 pointer-events-none">
            <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, defineProps, defineEmits } from 'vue'

const props = defineProps({
    modelValue: String,
    label: {
        type: String,
        required: true
    }
})

defineEmits(['update:modelValue'])

const isFocused = ref(false)

const hasValue = computed(() => props.modelValue && props.modelValue.length > 0)

const labelClasses = computed(() => {
    const hasContent = hasValue.value;
    const shouldFloat = isFocused.value || hasContent;


    return {
        'top-3 text-gray-500': !shouldFloat,
        '-top-2 text-primary text-xs bg-white px-1': shouldFloat
    }
})
</script>
